import { Navigate, Outlet, useLocation } from 'react-router';
import { useSessionStore } from '../../lib/session';

/**
 * The funnel guard (09-web-member § 2). A guest is sent to `/login` and the
 * intended step is remembered, so the purchase resumes where it was interrupted
 * rather than starting over.
 */
export function RequireSession() {
  const token = useSessionStore((state) => state.token);
  const location = useLocation();

  if (!token) {
    sessionStorage.setItem('cowoo.returnTo', location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
